
<app-base-template (modal)="openModal(content)" (tabledata)="getTableData()" [displayData]="displayData" [nextOffset]="nextOffset"
                   [previousOffset]="previousOffset" (offset)="getData($event)"
                   (pageSize)="onPageSizeChange($event)" [pageNo]="page_no" [totalPage]="totalPage" [dataLoaded]="dataLoaded"></app-base-template>
<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Add Schedule Ticket Configuration.</div>

  </div>
  <div class="modal-body">
    <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="ticketSelected"
              (change)="onTicketChange($event.target.selectedIndex)">
        <option *ngFor="let ticket of ttypes" [value]="ticket.id">{{ticket.name}}</option>
      </select>
    </div>


    <div class="row ">
      <div class="col-md-12 pad-15 category">
        <div class="height-40" [hidden]="categoryLoaded">
          <img class="loading-gif-42" src="../../../assets/img/loader-42px.gif">
        </div>
        <select class="custom-select  tcktyp" *ngFor="let ticket of ticketTypes;" [disabled]="ticket.isDisabled"
                (change)="onCategoryChange(ticket,$event.target.value)" id="ticket_{{ticket.id}}"
                [hidden]="!categoryLoaded">
          <option *ngFor="let option of ticket.options" [value]="option|json">{{option.title}}</option>
        </select>
      </div>
    </div>



    <div class=" mar-lft-rgt-0">
      <div class="row" style=" margin-left: 15px;">
          <div class="margin" *ngFor="let field of dynamicFields;" [ngSwitch]="field.fieldType">
              <input [ngClass]="field.isQuestion? ' ' : 'col-sm-12'" *ngSwitchCase="'1'" [hidden]="field.isQuestion" type="text" class="form-control radius-0 font-13 marginTop" placeholder="{{field.fieldName}}"[(ngModel)]="field.value">
              <mat-form-field *ngSwitchCase="'4'" class="col-sm-2 matcss">
                  <mat-label>{{field.fieldName}}</mat-label>
                  <mat-select [(ngModel)]="field.value">
                      <mat-option *ngFor="let opt of field.values" [value]="opt"
                      >{{opt}}</mat-option>
                  </mat-select>
              </mat-form-field>
              <div class="form-group  marginTop" *ngSwitchCase="'1'" [hidden]="!field.isQuestion">
                  <div class="row margin2">
  
                      <label class="col-sm-6 col-form-label label1 ">{{field.fieldName}}</label>
                      <div class="col-sm-6">
                          <div class="form-group">
                              <input type="text" class="form-control radius-0 font-13 " [(ngModel)]="field.value" (keypress)="blockSpecialChar($event)" maxlength="200"/>
                          </div>
                      </div>
  
                  </div>
              </div>
              <div class="form-group  marginTop" *ngSwitchCase="'7'" [hidden]="!field.isQuestion">
                  <div class="row margin2">
  
                      <label class="col-sm-7 col-form-label label1 ">{{field.fieldName}}</label>
                      <div class="col-sm-5">
                          <div class="form-group">
                              <textarea class="form-control radius-0 font-13 heighttxt" [(ngModel)]="field.value" (keypress)="blockSpecialChar($event)" maxlength="200"></textarea>
                          </div>
                      </div>
  
                  </div>
              </div>
              <div class="form-group" *ngSwitchCase="'2'">
                  <div class="row margin2 date-type">
                      <div class="form-group">
                          <input [hidden]="field.isQuestion" class="form-control radius-0 font-13 marginTop"
                                 placeholder="{{field.fieldName}}" [(ngModel)]="field.value" [owlDateTimeTrigger]="dt"
                                 [owlDateTime]="dt">
                          <owl-date-time [pickerType]="'calendar'" #dt></owl-date-time>
                      </div>
                  </div>
              </div>
              <div class="form-group " *ngSwitchCase="'5'">
                  <div class="row margin2 date-type">
                      <div class="form-group">
                          <input [hidden]="field.isQuestion" class="form-control radius-0 font-13 marginTop"
                                 placeholder="{{field.fieldName}}" [(ngModel)]="field.value" [owlDateTimeTrigger]="dt"
                                 [owlDateTime]="dt">
                          <owl-date-time [pickerType]="'timer'" #dt></owl-date-time>
                      </div>
                  </div>
              </div>
              <div class="form-group " *ngSwitchCase="'6'">
                  <div class="row margin2 date-type">
                      <div class="form-group">
                          <input [hidden]="field.isQuestion" class="form-control radius-0 font-13 marginTop"
                                 placeholder="{{field.fieldName}}" [(ngModel)]="field.value" [owlDateTimeTrigger]="dt"
                                 [owlDateTime]="dt">
                          <owl-date-time #dt></owl-date-time>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>


    <div class="form-group">
      <input type="text" class="form-control radius-0 font-13 "
             placeholder="Enter Requester info (Ex. Name, phone number , email etc)"
             [(ngModel)]="name" title="{{name}}" readonly>
    </div>

    <div class="form-group">
      <input type="text" class="form-control radius-0 font-13" [(ngModel)]="ticketTitle"
             placeholder="Ticket title">
    </div>

    <div class="form-group">
      <textarea class="form-control radius-0 font-13" [(ngModel)]="ticketDesc" placeholder="Ticket description" ></textarea>
    </div>

      <div class="form-group"  *ngIf="ticketTypeSeq===5">
          <div class="row schedule-div">

              <div class="row margin2 date-type">
                  <div class="form-group">
                      <input class="form-control radius-0 font-13 marginTop widthBox" placeholder="Schedule Start Date"
                             [(ngModel)]="scheduleStartDate" readonly [owlDateTimeTrigger]="dt3" [owlDateTime]="dt3">
                      <owl-date-time [pickerType]="'calendar'" #dt3></owl-date-time>
                  </div>
              </div>

              <div class="row margin2 date-type">
                  <div class="form-group">
                      <input class="form-control radius-0 font-13 marginTop widthBox" placeholder="Schedule Duration(in min)"
                             [(ngModel)]="scheduleDuration" type="number" min="0">
                  </div>
              </div>

              <div class="form-group">
                  <div class="row margin2 date-type">
                      <div class="form-group">
                          <input class="form-control radius-0 font-13 marginTop widthBox"
                                 placeholder="Planned Activity Start Date/Time" readonly [(ngModel)]="plannedStartDt"
                                 [owlDateTimeTrigger]="dt1" [owlDateTime]="dt1">
                          <!--[ngModelOptions]="{standalone: true}" (ngModelChange)="fromDateChanged()"-->
                          <owl-date-time #dt1></owl-date-time>
                      </div>
                  </div>
              </div>

              <div class="form-group">
                  <div class="row margin2 date-type">
                      <div class="form-group">
                          <input class="form-control radius-0 font-13 marginTop widthBox"
                                 placeholder="Planned Activity End Date/Time" readonly [(ngModel)]="plannedEndDt"
                                 [owlDateTimeTrigger]="dt2" [owlDateTime]="dt2">
                          <owl-date-time #dt2></owl-date-time>
                      </div>
                  </div>
              </div>
              <!--<div class="row margin2 date-type">-->
              <!--<div class="form-group">-->
              <!--<button type="button" (click)="checkConflicket()" class="btn btn-primary radius-0 font-13 marginTop ">-->
              <!--Check conflict-->
              <!--</button>-->
              <!--</div>-->
              <!--</div>-->
          </div>
      </div>

      <div class="row form-group">
          <div class="col-sm-4 pad-15" *ngIf="priorityType===1">
              <select class="custom-select font-13" [(ngModel)]="impact">
                  <option *ngFor="let map of impacts" [value]="map.id">{{map.name}}</option>
              </select>
          </div>
          <div class="col-sm-4 pad-15" *ngIf="priorityType===1">
              <select class="custom-select font-13" [(ngModel)]="urgency">
                  <option *ngFor="let map of urgencies" [value]="map.id">{{map.name}}</option>
              </select>
          </div>
          <div class="col-sm-4 pad-15" *ngIf="priorityType===1">
              <!--<input class="form-control radius-0 font-13" type="text" [(ngModel)]="priority" placeholder="Priority" readonly>-->
              <select class="custom-select font-13" [(ngModel)]="selectedPriority">
                  <option *ngFor="let priority of priorityArr" [value]="priority.id">{{priority.priority}}</option>
              </select>
          </div>
      </div>

    <div>
      <input class="form-control radius-0 font-13" [owlDateTimeTrigger]="dt8" [owlDateTime]="dt8"
             placeholder="Scheduled Date/Time " [(ngModel)]="activityValue" [min]="minDate" readonly>
      <owl-date-time [pickerType]="'both'" #dt8></owl-date-time>
    </div>
  </div>

  <div class="modal-footer pad-8">
    <button type="button" class="btn btn-success radius-0" (click)="save()">Save</button>
    <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>
</ng-template>
<ng-template #openActivityValueDetail>
  <div class="modal-header  color">
    <h4 class="modal-title" id="modal-basic-title">Schedule Details</h4>
    <!-- <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
    </button> -->
  </div>
  <div class="modal-body">


  <form class="form-horizontal">
      <div class="form-group">
        <div class="row">
          <label class="control-label col-sm-3 bold" >Ticket Type:</label>
          <div class="col-sm-9">
            <textarea class="form-control" [value]="itemValue.ticketType" readonly></textarea>
          </div>
        </div>
      </div>
      <div class="form-group">
          <div class="row">
            <label class="control-label col-sm-3 bold" >Ticket category:</label>
            <div class="col-sm-9">
              <textarea class="form-control" [value]="itemValue.category" readonly></textarea>
            </div>
          </div>
        </div>
        <div class="form-group">
            <div class="row">
              <label class="control-label col-sm-3 bold" >Ticket Title:</label>
              <div class="col-sm-9">
                <textarea class="form-control" [value]="itemValue.ticket_title" readonly></textarea>
              </div>
            </div>
          </div>
          
            <div class="form-group">
                <div class="row">
                  <label class="control-label col-sm-3 bold" >Ticket Description:</label>
                  <div class="col-sm-9">
                    <textarea class="form-control" [value]="itemValue.ticket_description" readonly></textarea>
                  </div>
                </div>
              </div>
            <div class="form-group">
                  <div class="row">
                    <label class="control-label col-sm-3 bold" for="email">Activity type:</label>
                    <div class="col-sm-9">
                      <textarea class="form-control" [value]="itemValue.activity_type" readonly></textarea>
                    </div>
                  </div>
                </div>  
    </form>

   
   

   
   

   
    
<div class="backColor">
   <div class="adhoc " [hidden]="!adhocLoad">
    <p *ngFor="let values of value2;">{{values}}</p>
   </div>
   <div class="daily" [hidden]="!dailyLoad">
      <p *ngFor="let values of value2;">{{values}}</p>
   </div>
    
    <div class="row weekly paddinglft" [hidden]="!weeklyLoad">
      <div class="col-sm-3">
        <div class="row inline" *ngFor="let values of value3;">
          <label  class="label bold">Day:</label >
          <p>{{values}}</p>
        </div>
      </div>
      <div class="col-sm-8">
        <div class="row inline" *ngFor="let value of value4;">
          <label  class="label bold" >Time:</label >
            <p>{{value}}</p>
        </div>
      </div>
    </div>
   
    <div class=" row monthly paddinglft" *ngFor="let values of value5;" [hidden]="!monthlyLoad">
        <div class="col-sm-4">
            <div class="inline ">
               <label class="bold">Month:</label >
               <p> {{values.month}}</p>
               </div>
             </div>
                
             <div class="col-sm-4">
               <div class="inline">  
               <label class="bold">Date:</label>
               <p> {{values.date}}</p>
               </div>
       
               </div>
               <div class="col-sm-4">
               <div class="inline">
               <label class="bold">Time:</label>
               <p> {{values.time}}</p>
               </div>
               </div>
        </div>       
      
      
   
<div *ngFor="let values of value6;" [hidden]="!quarterlyLoad">
    <div class="inline mrginlft">
        <label class="bold" >Quarter:</label >
        <p> {{values.quarter}}</p>
        </div>
<div class=" row Quarterly paddinglft "   >
  <div class="col-sm-4">
     <div class="inline">
        <label >Month:</label >
        <p> {{values.month}}</p>
        </div>
      </div>
         
      <div class="col-sm-4">
        <div class="inline">  
        <label>Day:</label>
        <p> {{values.day}}</p>
        </div>

        </div>
        <div class="col-sm-4">
        <div class="inline">
        <label>Time:</label>
        <p> {{values.time}}</p>
        </div>
        </div>
        
      </div>

    </div>
    <!-- ngfor -->




    </div>
    <!-- backColor -->
   
   
     
  </div>
  
  <div class="modal-footer pad-8">
      <button type="button" class="btn btn-danger radius-0" (click)="c()">Close</button>
  </div>
    
</ng-template>

<notifier-container></notifier-container>
